"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonDrawer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _customProps = require("../../../../utils/customProps");

var _Button = _interopRequireDefault(require("../../../../components/PageGrid/molecules/Button/Button"));

var _Drawer = _interopRequireDefault(require("../../../../components/PageGrid/molecules/Drawer/Drawer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * ButtonDrawer controls Drawer open state from true to false.
 * More docs and demos at https://material-ui.com/api/button/ and  https://material-ui.com/api/Drawer/
 * Uses MuiButton and MuiDrawer
 */
var ButtonDrawer = function ButtonDrawer(_ref) {
  var drawer = _ref.drawer,
      button = _ref.button;

  var _useState = (0, _react.useState)({
    open: false
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var toggleDrawer = function toggleDrawer() {
    return setState(_objectSpread(_objectSpread({}, state), {}, {
      open: !state.open
    }));
  };

  var muiDrawer = drawer[0];
  var muibutton = button[0];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, muibutton, {
    onClick: toggleDrawer
  })), /*#__PURE__*/_react.default.createElement(_Drawer.default, (0, _extends2.default)({}, muiDrawer, {
    open: state.open,
    toggleDrawer: toggleDrawer
  })));
};

exports.ButtonDrawer = ButtonDrawer;
var _default = ButtonDrawer;
exports.default = _default;
ButtonDrawer.propTypes = {
  /** MuiButton Allowed maximum: 1 */
  button: function button(props, propName, componentName) {
    var components = ['Button'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** MuiDrawer Allowed maximum: 1 */
  drawer: function drawer(props, propName, componentName) {
    var components = ['Drawer'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  }
};
ButtonDrawer.defaultProps = {
  button: [],
  drawer: []
};